import { Star, Quote, PencilLine } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { REVIEWS, REVIEW_LINK } from "@/lib/site";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative bg-obsidian py-16 sm:py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>Verified Reviews</Eyebrow>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
            Driveways <span className="text-ember">talk.</span>
          </h2>
        </div>
        <div className="flex items-center gap-2" data-testid="reviews-rating-badge">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-ember fill-ember" />
            ))}
          </div>
          <span className="font-display font-bold text-2xl">5.0</span>
          <span className="text-mist text-sm">Google Rating</span>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.12}>
            <figure
              data-testid={`review-card-${i}`}
              className="relative h-full bg-panel border border-white/10 rounded-sm p-8 hover:border-ember/40 hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="w-8 h-8 text-ember/40 absolute top-6 right-6" strokeWidth={1.5} />
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-ember fill-ember" />
                ))}
              </div>
              <blockquote className="mt-5 text-sm leading-relaxed text-[#D5DCE5]">“{r.text}”</blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/10">
                <p className="font-display font-bold uppercase tracking-wider text-lg">{r.name}</p>
                <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-mist mt-1">{r.area} — Verified Customer</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3} className="mt-10 text-center">
        <a
          data-testid="leave-review-btn"
          href={REVIEW_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-ember/50 text-ember font-display font-bold uppercase tracking-wider px-7 py-3 rounded-sm hover:bg-ember hover:text-obsidian transition-all duration-200"
        >
          <PencilLine className="w-5 h-5" /> Leave a Google Review
        </a>
        <p className="mt-3 text-mist text-xs">Had work done by us? 60 seconds of your time helps the next driver find honest service.</p>
      </Reveal>
    </div>
  </section>
);
